class AgeVerification extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.age-gate');
    this.checkbox = this.querySelector('.age-gate__checkbox');
    this.confirmButton = this.querySelector('.age-gate__button');
    if (!this.dialog || !this.checkbox || !this.confirmButton) return;

    // The ticket requires the overlay to be dismissable only via the checkbox +
    // confirm flow, so block the native dialog's Escape-to-close behaviour.
    this.dialog.addEventListener('cancel', (event) => event.preventDefault());

    this.checkbox.addEventListener('change', () => {
      this.confirmButton.disabled = !this.checkbox.checked;
    });

    this.confirmButton.addEventListener('click', () => this.accept());
  }

  accept() {
    if (!this.checkbox.checked) return;
    // ~6 months. Secure is ignored on http, so local theme previews still work.
    const maxAge = 60 * 60 * 24 * 182;
    document.cookie = `karakter_age_verified=true; Max-Age=${maxAge}; path=/; SameSite=Lax; Secure`;
    this.dialog.close();
    document.documentElement.classList.remove('age-gate-open');
  }
}

customElements.define('age-verification', AgeVerification);
